import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    text: 'Descargas la guía PDF inmediatamente después de tu compra.'
  }, {
    num: '2',
    text: 'Aplicas la "Regla del 1-2-3" en tu café de mañana mismo.'
  }, {
    num: '3',
    text: 'Sigues el plan de comidas deliciosas y ves cómo tu energía se dispara y tu inflamación baja día tras día.'
  }];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-128">
      <FadeIn data-id="element-129">
        <div className="text-center mb-16" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-brown mb-4" data-id="element-131">
            CÓMO FUNCIONA:
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-132"></div>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-133">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-cinnamon/20 -z-10" data-id="element-134"></div>

        {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative" data-id="element-135">
            <div className="flex flex-col items-center text-center" data-id="element-136">
              <div className="w-24 h-24 bg-cream border-4 border-cinnamon rounded-full flex items-center justify-center text-4xl font-serif font-bold text-cinnamon mb-6 shadow-sm bg-white" data-id="element-137">
                {step.num}
              </div>
              <p className="text-lg text-dark-brown/80 font-medium px-4" data-id="element-138">
                {step.text}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}